import { render, staticRenderFns } from "./SmsPointSummary.vue?vue&type=template&id=6daef2f5&scoped=true&"
import script from "./SmsPointSummary.vue?vue&type=script&lang=ts&"
export * from "./SmsPointSummary.vue?vue&type=script&lang=ts&"
import style0 from "./SmsPointSummary.vue?vue&type=style&index=0&id=6daef2f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daef2f5",
  null
  
)

export default component.exports